import { fetchQuery, graphql, Environment } from 'relay-runtime';
// import { Environment } from 'react-relay';
import UnRegisterCustomerDealerMutation from '../../../mutationsModern/User/ShopWithCustomerDeleteMutation';
import {
  handleArchivedUserQuery as handleArchivedUserQueryType,
  // AppHandlePromoCodeAutoAddQueryResponse,
} from './__generated__/handleArchivedUserQuery.graphql';
import handleLogout from './handleLogout';

const handleArchivedUserQuery = graphql`
  query handleArchivedUserQuery($accountId: String) {
    viewer {
      id
      id
      userInfo(accountId: $accountId) {
        id
        isArchived
        conciergeUser {
          id
          isArchived
        }
      }
    }
  }
`;

const handleCartHotSwap = () => {
  window.location.reload();
};

const removeCustomerCart = (environment: Environment) => {
  UnRegisterCustomerDealerMutation.commit({
    environment,
    onCompleted: () => {
      console.log('customer shopping removed');
      handleCartHotSwap();
    },
    onError: trans => {
      console.log('TRANS error: ', trans);
    },
  });
};

export function handleArchivedUser(
  environment: Environment,
  accountId?: string,
) {
  // No account Id or accountId is a guest ID
  if (!accountId || accountId.includes('.')) {
    return;
  }
  return fetchQuery<handleArchivedUserQueryType>(
    environment,
    handleArchivedUserQuery,
    {
      accountId,
    },
  ).then(data => {
    const { viewer } = data;
    if (viewer) {
      const { userInfo } = viewer;
      if (userInfo) {
        const { conciergeUser, isArchived } = userInfo;
        if (conciergeUser && conciergeUser.isArchived) {
          removeCustomerCart(environment);
        }
        if (isArchived) {
          // @ts-ignore: wrong environment var
          handleLogout()(environment);
        }
      }
    }
  });
}
